import { css } from '@emotion/react';
import {
  Badge,
  colors,
  designTokens,
  RiFilter3Line,
  type DeepReadonly
} from '@itandi/itandi-bb-ui';
import type { ComponentProps, FC } from 'react';

type Props = DeepReadonly<{
  /** Badge に表示する数（指定した場合は Badge が表示される） */
  badge?: number;
  /** button の onClick */
  onClick?: ComponentProps<'button'>['onClick'];
}>;

/**
  @deprecated 削除したい場合は相談ワークフローからデザインの修正を依頼してください（新しい画面では使わないでください）
 */
export const AdvancedSearchButton: FC<Props> = ({ badge, onClick }) => (
  <button
    css={css({
      '&:hover': { backgroundColor: colors['gray-300'] },
      backgroundColor:
        typeof badge === 'number' ? colors['gray-200'] : undefined,
      borderRadius: 9999,
      color: colors['semantic-link'],
      display: 'flex',
      padding: '4px 8px'
    })}
    onClick={onClick}
    type="button"
  >
    <RiFilter3Line css={css({ height: 18, width: 18 })} />
    <span
      css={css({
        fontSize: designTokens['text/label/s'],
        fontWeight: 'bold',
        paddingLeft: 2,
        paddingRight: 2,
        width: 'initial'
      })}
    >
      詳細検索
    </span>
    {typeof badge === 'number' && badge !== 0 && (
      <Badge count={badge} variant="info" />
    )}
  </button>
);
